module.exports = __webpack_public_path__ + "static/img/chenlong.af29d48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touxiang/chenlong.png
// module id = s1aA
// module chunks = 0